import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Allow access to auth route without authentication
    if (state.url.includes('/auth')) {
      return true;
    }
    
    if (this.isAuthenticated()) {
      return true;
    } else {
      this.clearAuthData();
      return this.router.createUrlTree(['/auth']);
    }
  }

  private isAuthenticated(): boolean {
    const token = localStorage.getItem('auth.access_token');
    const expiresOn = localStorage.getItem('auth.expires_on');
    
    if (!token || !expiresOn) {
      return false;
    }
    
    const isExpired = parseFloat(expiresOn) < Date.now() / 1000;
    
    if (isExpired) {
      this.clearAuthData();
      return false;
    }
    
    return true;
  }

  private clearAuthData(): void {
    localStorage.removeItem('auth.access_token');
    localStorage.removeItem('auth.expires_on');
    localStorage.removeItem('auth.user_info');
  }
}